import React, { useEffect } from "react";
import { Card, Table, Layout, Space, Typography } from "antd";
import { observer } from "mobx-react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { articleCommentsStore } from "../../store/content/article/ArticleCommentsStore";
import { ArticleInfo } from "./ArticleInfo";
import { fmtDateTime } from "../../common/Utils";

export const ArticleComments = observer(() => {
  let { id } = useParams<any>();
  const location = useLocation();
  const history = useHistory();

  const store = articleCommentsStore;

  const onPage = (page, pageSize) => {
    store.onPage(history, page, pageSize);
  };
  useEffect(() => {
    store.filter.articleId = id;
    store.onLocation(location);
  }, []);

  useEffect(() => {
    store.filter.articleId = id;
    store.onLocation(location);
  }, [location.search]);

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "User",
      dataIndex: "createdBy",
    },
    {
      title: "Time",
      dataIndex: "CreatedAt",
      render: fmtDateTime,
    },
    {
      title: "Comment",
      dataIndex: "Comment",
      width: "80%",
      render: (v) => <Typography.Paragraph style={{ overflowWrap: "anywhere" }}>{v}</Typography.Paragraph>,
    },
    {
      title: "",
      render: (_, r) => (
        <Space>
          <a>Reply</a>
        </Space>
      ),
    },
  ];

  return (
    <Layout.Content className="padding24">
      <ArticleInfo article={store.article} />

      <Card size="small" title="Article Comments" bodyStyle={{ padding: 0 }}>
        <Table
          size="small"
          pagination={{ ...store.pagination, onChange: onPage }}
          // loading={store.loading}
          rowKey={(r) => `${r.orgId}_${r.childId}`}
          columns={columns}
          dataSource={store.data.items}
        />
      </Card>
    </Layout.Content>
  );
});
